/**
 * Storelli money-format compatibility patch.
 *
 * Palo Alto 6.2.0's bundled formatter only handles four Shopify money
 * placeholders. Shopify Markets can return additional placeholders for
 * localized currencies (for example SEK), which causes the dynamic variant
 * price renderer to fail/blank on variant changes.
 *
 * Keep this file loaded after vendor.js and before theme.js.
 */
(function () {
  if (!window.themeVendor || !window.themeVendor.themeCurrency) return;

  var defaultFormat = '${{amount}}';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;

    if (number == null || isNaN(number)) return '0';

    var parts = (Number(number) / 100).toFixed(precision).split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      // Match the behavior of Shopify's legacy formatter for string cents.
      cents = cents.replace('.', '');
    }

    var formatString = format || defaultFormat;
    var match = formatString.match(placeholderRegex);

    // Do not throw if Shopify/app markup provides a format without a known token.
    if (!match) return formatString;

    var value;

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;

      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;

      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;

      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;

      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;

      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;

      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;

      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;

      default:
        // Preserve the format rather than returning a blank value.
        return formatString;
    }

    return formatString.replace(placeholderRegex, value);
  }

  window.themeVendor.themeCurrency = Object.freeze({
    formatMoney: formatMoney
  });
})();